import { useAuth } from "$/util/auth";
import { ArrowCircleDown } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function DownloadIconButton(props) {
  const { downloadClickCallback } = props;
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLockClick = () => {
    downloadClickCallback();
    // if (!user) {
    //   navigate("/login");
    //   return;
    // }
  };
  return (
    <IconButton
      aria-label="favorite"
      color={"primary"}
      onClick={handleLockClick}
      sx={{ borderRadius: "25%", minWidth: 40, height: 40 }}
    >
      {<ArrowCircleDown />}
    </IconButton>
  );
}

export default DownloadIconButton;
